import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    firstVehicle: null,
    secondVehicle: null,
    toCompare: [],
    isSmall: window.innerWidth <= 360
  },
  mutations: {
    ADD_TO_COMPARISON(state, {id, toast}) {

      if(!!state.firstVehicle && !!state.secondVehicle)
      {
        Vue.set(state, 'firstVehicle', id)
        Vue.set(state, 'secondVehicle', null)
        Vue.set(state, 'toCompare', [id])
      }
      else {
        if(!state.firstVehicle)
          Vue.set(state, 'firstVehicle', id)
        else if(!state.secondVehicle)
          Vue.set(state, 'secondVehicle', id)
          
        state.toCompare.push(id);
        Vue.set(state, 'toCompare', [...state.toCompare])
      }

      if(state.toCompare.length == 1)
        toast.show('Wähle ein weiteres Auto zum Vergleichen aus', {
          position: 'bottom-center',
          closeOnSwipe: true,
          duration: 3000
        })
    },
    REMOVE_FROM_COMPARISON(state, id) {
      if(state.firstVehicle === id)
        Vue.set(state, 'firstVehicle', null)
      else if(state.secondVehicle === id)
        Vue.set(state, 'secondVehicle', null)

      let index = state.toCompare.indexOf(id);
      state.toCompare.splice(index, 1);

      Vue.set(state, 'toCompare', [...state.toCompare])
    },
    SET_IS_SMALL(state, val) {
      Vue.set(state, 'isSmall', val);
    }
  },
  actions: {
  },
  modules: {
  }
})
